import { createFileRoute } from "@tanstack/react-router";
import { MarketingHero } from "@/components/marketing-hero";
import { MarketingPageShell } from "@/components/marketing-page-shell";
import { HomepageAgentInstall } from "@/components/setup/homepage-agent-install";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/chatgpt-social-media";

export const Route = createFileRoute(path)({
	component: ChatGptSocialMedia,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "Boost your Social Media using ChatGPT",
			description:
				"Use ChatGPT as an AI social media scheduler. Connect AgentReacher's MCP server so ChatGPT can draft, adapt, schedule, and publish posts from chat.",
		}),
});

function ChatGptSocialMedia() {
	return (
		<MarketingPageShell>
			<MarketingHero
				agent="chatgpt"
				title="Boost your Social Media using ChatGPT"
				description="AgentReacher gives ChatGPT real publishing tools through MCP. Ask for a launch campaign, approve the drafts, and watch the calendar fill without copying captions between tabs."
				primaryCta={{ label: "Connect ChatGPT", to: "/connect-chatgpt" }}
				secondaryCta={{ label: "Setup docs", to: "/connect-chatgpt" }}
			/>

			<HomepageAgentInstall />
		</MarketingPageShell>
	);
}
